// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_FOIaR {
  height: 100%;
  overflow: auto !important;
  display: flex;
  flex-direction: column;
}

.fill_J3nGF.win_AtQ53 {
  flex-grow: 1;
  width: 100%;
  position : sticky;
  left : 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/table/TableView.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,QAAQ;AACV","sourcesContent":[".table {\n  height: 100%;\n  overflow: auto !important;\n  display: flex;\n  flex-direction: column;\n}\n\n.fill.win {\n  flex-grow: 1;\n  width: 100%;\n  position : sticky;\n  left : 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_FOIaR`,
	"fill": `fill_J3nGF`,
	"win": `win_AtQ53`
};
export default ___CSS_LOADER_EXPORT___;
